import { useEffect, useState } from "react";
import {
  getVisibleDialogFrame,
  type VisibleDialogFrame,
} from "@/lib/visibleDialogFrame";

export const useVisibleDialogFrame = (open: boolean) => {
  const [frame, setFrame] = useState<VisibleDialogFrame>();

  useEffect(() => {
    if (!open) {
      setFrame(undefined);
      return;
    }

    const updateFrame = () => setFrame(getVisibleDialogFrame());
    const viewport = window.visualViewport;

    updateFrame();
    viewport?.addEventListener("resize", updateFrame);
    viewport?.addEventListener("scroll", updateFrame);
    window.addEventListener("orientationchange", updateFrame);

    return () => {
      viewport?.removeEventListener("resize", updateFrame);
      viewport?.removeEventListener("scroll", updateFrame);
      window.removeEventListener("orientationchange", updateFrame);
    };
  }, [open]);

  return frame;
};